module.exports = __webpack_public_path__ + "img/banner.83fc620c.svg";